// extracted by mini-css-extract-plugin
export default {"fastConv":"FastConv_fastConv__I91iT","title":"FastConv_title__2uAex","cards":"FastConv_cards__LOdXm","image":"FastConv_image__0fneC"};